import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo, cloneElement } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { IMAGE_SIZE_VARIANTS, DEFAULT_IMAGE_SIZE_VARIANT } from '../../constants.js';
import { getResponsiveSx, getStartingSize } from '../../utils/styleHelpers.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { F as FramedImage } from '../FramedImage/FramedImage.js';
import { b as getImageSizeMapping } from '../../utils/imageHelpers2.js';
import { B as Box } from '../Box/Box.js';
import { S as SmartClone } from '../SmartClone/SmartClone.js';
import { useTheme } from '../../hooks/useTheme.js';
import { useGetResponsiveImageSizes, useGetRelativeImageSizeInLayout } from '../../hooks/responsiveImageSizeHooks.js';
import { useGetCurrentSizeClass } from '../../hooks/useGetCurrentSizeClass.js';
import { useGetSubcomponentChild } from '../../hooks/useGetSubcompnentChild.js';

var _excluded$1 = ["use", "className", "testId"],
  _excluded2 = ["use", "testId", "className"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SwapStackPrimaryImage(_ref) {
  var use = _ref.use,
    className = _ref.className,
    testId = _ref.testId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return jsx(FramedImage, _objectSpread$2(_objectSpread$2({}, props), {}, {
    use: use,
    testId: "".concat(testId, "__framedImage--left"),
    className: "".concat(className !== null && className !== void 0 ? className : "", " SwapStackPrimaryImage SwapStack__image SwapStack__image--left")
  }));
}
function SwapStackSecondaryImage(_ref2) {
  var use = _ref2.use,
    testId = _ref2.testId,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return jsx(FramedImage, _objectSpread$2(_objectSpread$2({}, props), {}, {
    use: use,
    testId: "".concat(testId, "__framedImage--right"),
    className: "".concat(className !== null && className !== void 0 ? className : "", " SwapStackSecondaryImage SwapStack__image SwapStack__image--right")
  }));
}

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var maskImagePrefix = "url('data:image/svg+xml;utf8,";
var svgXmlns = "xmlns=\"http://www.w3.org/2000/svg\"";
var swapContainerSx = {
  pos: "relative",
  d: "block",
  "&.SwapStack--left.SwapStack--circle.SwapStack--small > .SwapStack__image--right": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 16 16\" ").concat(svgXmlns, "><path d=\"M0.0618896 8.99951C0.553793 12.946 3.92028 15.9999 8.00005 15.9999C12.4183 15.9999 16.0001 12.4182 16.0001 7.99995C16.0001 3.92013 12.9461 0.55361 8.99947 0.0617676C8.96625 4.98305 4.98315 8.9662 0.0618896 8.99951Z\"/></svg>')")
  },
  "&.SwapStack--left.SwapStack--circle.SwapStack--medium > .SwapStack__image--right": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 20 20\" ").concat(svgXmlns, "><path d=\"M0.0706147 8.80541C0.0239869 9.19711 0 9.59575 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C9.59575 0 9.19711 0.0239869 8.80541 0.0706147C7.96454 4.48525 4.48525 7.96454 0.0706147 8.80541Z\"/></svg>')")
  },
  "&.SwapStack--left.SwapStack--circle.SwapStack--large > .SwapStack__image--right": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 32 32\" ").concat(svgXmlns, "><path d=\"M0.0307617 17.0002C0.547045 25.3708 7.49936 32 16 32C24.8366 32 32 24.8366 32 16C32 7.49934 25.3708 0.547005 17.0001 0.0307617C16.9836 9.39535 9.39534 16.9837 0.0307617 17.0002Z\"/></svg>')")
  },
  "&.SwapStack--left.SwapStack--circle.SwapStack--xLarge > .SwapStack__image--right": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 48 48\" ").concat(svgXmlns, "><path d=\"M1.40918 32.1222C4.73812 41.3799 13.5959 48.0001 24 48.0001C37.2548 48.0001 48 37.2549 48 24.0001C48 13.5959 41.3797 4.73805 32.1219 1.40918C32.6943 3.509 32.9999 5.71887 32.9999 8.00011C32.9999 21.8072 21.807 33.0001 7.99986 33.0001C5.71871 33.0001 3.50892 32.6946 1.40918 32.1222Z\"/></svg>')")
  },
  "&.SwapStack--left.SwapStack--square.SwapStack--small > .SwapStack__image--right": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 16 16\" ").concat(svgXmlns, "><path d=\"M5.0541e-05 8.99972V13.9999C5.0541e-05 15.1045 0.895481 15.9999 2.00005 15.9999H14.0001C15.1046 15.9999 16.0001 15.1045 16.0001 13.9999V1.99995C16.0001 0.895376 15.1046 -5.44265e-05 14.0001 -5.44265e-05H8.99968V3.99972C8.99968 6.76114 6.76111 8.99972 3.99968 8.99972H5.0541e-05Z\"/></svg>')")
  },
  "&.SwapStack--left.SwapStack--square.SwapStack--medium > .SwapStack__image--right": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 20 20\" ").concat(svgXmlns, "><path d=\"M0 9V18C0 19.1046 0.895431 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.895431 19.1046 0 18 0H9V4C9 6.76142 6.76142 9 4 9H0Z\"/></svg>')")
  },
  "&.SwapStack--left.SwapStack--square.SwapStack--large > .SwapStack__image--right": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 32 32\" ").concat(svgXmlns, "><path d=\"M8.74698e-06 17.0002V28C8.74698e-06 30.2092 1.79087 32 4.00001 32H28C30.2091 32 32 30.2092 32 28V4.00001C32 1.79087 30.2091 1.38581e-05 28 1.38581e-05H17.0001V12.0002C17.0001 14.7616 14.7616 17.0002 12.0001 17.0002H8.74698e-06Z\"/></svg>')")
  },
  "&.SwapStack--left.SwapStack--square.SwapStack--xLarge > .SwapStack__image--right": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 48 48\" ").concat(svgXmlns, "><path d=\"M0 33V44C0 46.2091 1.79086 48 4 48H44C46.2091 48 48 46.2091 48 44V4C48 1.79086 46.2091 0 44 0H33V28C33 30.7614 30.7614 33 28 33H0Z\" /></svg>')")
  },
  "&.SwapStack--right.SwapStack--circle.SwapStack--small > .SwapStack__image--left": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 16 16\" ").concat(svgXmlns, "><path d=\"M8 0C3.58172 0 0 3.58172 0 8C0 12.0797 3.0538 15.4461 7.00021 15.9381C7.03334 11.0167 11.0167 7.03334 15.9381 7.00021C15.4461 3.0538 12.0797 0 8 0Z\"/></svg>')")
  },
  "&.SwapStack--right.SwapStack--circle.SwapStack--medium > .SwapStack__image--left": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 20 20\" ").concat(svgXmlns, "><path d=\"M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C10.4042 20 10.8029 19.976 11.1946 19.9294C12.0355 15.5147 15.5147 12.0355 19.9294 11.1946C19.976 10.8029 20 10.4042 20 10C20 4.47715 15.5228 0 10 0Z\"/></svg>')")
  },
  "&.SwapStack--right.SwapStack--circle.SwapStack--large > .SwapStack__image--left": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 32 32\" ").concat(svgXmlns, "><path d=\"M16 0C7.16344 0 0 7.16344 0 16C0 24.5007 6.62929 31.4531 15 31.9693C15.0166 22.6048 22.6048 15.0166 31.9693 15C31.4531 6.62929 24.5007 0 16 0Z\"/></svg>')")
  },
  "&.SwapStack--right.SwapStack--circle.SwapStack--xLarge > .SwapStack__image--left": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 48 48\" ").concat(svgXmlns, "><path d=\"M24 0C10.7452 0 0 10.7452 0 24C0 34.4041 6.62021 43.2619 15.8779 46.5908C15.3055 44.491 15 42.2812 15 40C15 26.1929 26.1929 15 40 15C42.2812 15 44.491 15.3055 46.5908 15.8779C43.2619 6.62021 34.4041 0 24 0Z\"/></svg>')")
  },
  "&.SwapStack--right.SwapStack--square.SwapStack--small > .SwapStack__image--left": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 16 16\" ").concat(svgXmlns, "><path d=\"M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H7V12C7 9.23858 9.23858 7 12 7H16V4C16 1.79086 14.2091 0 12 0H4Z\"/></svg>')")
  },
  "&.SwapStack--right.SwapStack--square.SwapStack--medium > .SwapStack__image--left": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 20 20\" ").concat(svgXmlns, "><path d=\"M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H11V16C11 13.2386 13.2386 11 16 11H20V2C20 0.895431 19.1046 0 18 0H2Z\"/></svg>')")
  },
  "&.SwapStack--right.SwapStack--square.SwapStack--large > .SwapStack__image--left": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 32 32\" ").concat(svgXmlns, "><path d=\"M4 0C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H15V20C15 17.2386 17.2386 15 20 15H32V4C32 1.79086 30.2091 0 28 0H4Z\"/></svg>')")
  },
  "&.SwapStack--right.SwapStack--square.SwapStack--xLarge > .SwapStack__image--left": {
    WebkitMaskImage: "".concat(maskImagePrefix, " <svg viewBox=\"0 0 48 48\" ").concat(svgXmlns, "><path d=\"M4 0C1.79086 0 0 1.79086 0 4V44C0 46.2091 1.79086 48 4 48H15V20C15 17.2386 17.2386 15 20 15H48V4C48 1.79086 46.2091 0 44 0H4Z\"/></svg>')")
  }
};
var swapContainerImageSx = {
  pos: "absolute",
  WebkitMaskPosition: "left center",
  WebkitMaskRepeat: "no-repeat",
  WebkitMaskSize: "cover"
};
function getContainerSx(_ref) {
  var size = _ref.size,
    base = _ref.theme.base;
  var sizeMapping = {
    small: base.icon.size[300],
    medium: base.icon.size[400],
    large: base.icon.size[500],
    xLarge: base.icon.size[600]
  };
  return {
    width: sizeMapping[size],
    height: sizeMapping[size]
  };
}
var getResponsiveContainerSx = function getResponsiveContainerSx(props) {
  return getResponsiveSx(_objectSpread$1(_objectSpread$1({}, props), {}, {
    renderSxAtSize: getContainerSx
  }));
};
function getImageSx(_ref2) {
  var size = _ref2.size,
    base = _ref2.theme.base;
  var sizeMapping = getImageSizeMapping("SwapStack", {
    base: base
  });
  return {
    width: sizeMapping[size],
    height: sizeMapping[size]
  };
}
var getResponsiveImageSx = function getResponsiveImageSx(props) {
  return getResponsiveSx(_objectSpread$1(_objectSpread$1({}, props), {}, {
    renderSxAtSize: getImageSx
  }));
};

var _excluded = ["primaryImageUrl", "secondaryImageUrl", "circularFrame", "direction", "testId", "className", "children", "size", "sx"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SwapStack(_ref) {
  var _leftImageWithFallbac5, _rightImageWithFallba3;
  var primaryImageUrl = _ref.primaryImageUrl,
    secondaryImageUrl = _ref.secondaryImageUrl,
    circularFrame = _ref.circularFrame,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "left" : _ref$direction,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "SwapStack" : _ref$testId,
    className = _ref.className,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? DEFAULT_IMAGE_SIZE_VARIANT : _ref$size,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded);
  var startingSize = getStartingSize(size, DEFAULT_IMAGE_SIZE_VARIANT, IMAGE_SIZE_VARIANTS);
  var theme = useTheme();
  var containerSx = useMemo(function () {
    return merge(swapContainerSx, {
      pos: "relative"
    }, getContainerSx({
      theme: theme,
      size: startingSize
    }), getResponsiveContainerSx({
      theme: theme,
      size: size
    }), sx);
  }, [size, startingSize, sx, theme]);
  var baseImageSx = useMemo(function () {
    return merge(swapContainerImageSx, getImageSx({
      theme: theme,
      size: startingSize
    }), getResponsiveImageSx({
      theme: theme,
      size: size
    }));
  }, [size, startingSize, theme]);
  var responsiveSizes = useGetResponsiveImageSizes(size, "SwapStack");
  var relativeImageSizeInLayout = useGetRelativeImageSizeInLayout(size, "SwapStack");
  var relativeImageSizeInLayoutNumber = Number.parseInt(relativeImageSizeInLayout, 10);
  var sizeClass = useGetCurrentSizeClass(size, DEFAULT_IMAGE_SIZE_VARIANT, IMAGE_SIZE_VARIANTS);
  var leftImage = useGetSubcomponentChild(children, SwapStackPrimaryImage);
  var rightImage = useGetSubcomponentChild(children, SwapStackSecondaryImage);
  var leftImageWithFallback = useMemo(function () {
    if (leftImage) {
      return leftImage;
    }
    return primaryImageUrl ? jsx(SwapStackPrimaryImage, {
      imageUrl: primaryImageUrl,
      relativeImageSizeInLayout: relativeImageSizeInLayout
    }) : null;
  }, [leftImage, primaryImageUrl, relativeImageSizeInLayout]);
  var rightImageWithFallback = useMemo(function () {
    var _ref2, _leftImageWithFallbac, _leftImageWithFallbac2;
    if (rightImage) {
      return rightImage;
    }

    // @NOTE: if no image is supplied for the right image, we will simply use the left image
    var rightImageUrl = (_ref2 = secondaryImageUrl !== null && secondaryImageUrl !== void 0 ? secondaryImageUrl : primaryImageUrl) !== null && _ref2 !== void 0 ? _ref2 : leftImageWithFallback === null || leftImageWithFallback === void 0 || (_leftImageWithFallbac = leftImageWithFallback.props) === null || _leftImageWithFallbac === void 0 ? void 0 : _leftImageWithFallbac.imageUrl;
    var rightImageUseProp = leftImageWithFallback === null || leftImageWithFallback === void 0 || (_leftImageWithFallbac2 = leftImageWithFallback.props) === null || _leftImageWithFallbac2 === void 0 ? void 0 : _leftImageWithFallbac2.use;
    return rightImageUseProp ? jsx(SwapStackSecondaryImage, {
      use: rightImageUseProp
    }) : jsx(SwapStackSecondaryImage, {
      imageUrl: rightImageUrl,
      relativeImageSizeInLayout: relativeImageSizeInLayout
    });
  }, [rightImage, primaryImageUrl, secondaryImageUrl, leftImageWithFallback, relativeImageSizeInLayout]);
  var leftImageSx = useMemo(function () {
    var _leftImageWithFallbac3, _leftImageWithFallbac4;
    return merge(baseImageSx, {
      top: 0,
      left: 0
    }, (_leftImageWithFallbac3 = leftImageWithFallback === null || leftImageWithFallback === void 0 || (_leftImageWithFallbac4 = leftImageWithFallback.props) === null || _leftImageWithFallbac4 === void 0 ? void 0 : _leftImageWithFallbac4.sx) !== null && _leftImageWithFallbac3 !== void 0 ? _leftImageWithFallbac3 : {});
  }, [baseImageSx, leftImageWithFallback === null || leftImageWithFallback === void 0 || (_leftImageWithFallbac5 = leftImageWithFallback.props) === null || _leftImageWithFallbac5 === void 0 ? void 0 : _leftImageWithFallbac5.sx]);
  var rightImageSx = useMemo(function () {
    var _rightImageWithFallba, _rightImageWithFallba2;
    return merge(baseImageSx, {
      bottom: 0,
      right: 0
    }, (_rightImageWithFallba = rightImageWithFallback === null || rightImageWithFallback === void 0 || (_rightImageWithFallba2 = rightImageWithFallback.props) === null || _rightImageWithFallba2 === void 0 ? void 0 : _rightImageWithFallba2.sx) !== null && _rightImageWithFallba !== void 0 ? _rightImageWithFallba : {});
  }, [baseImageSx, rightImageWithFallback === null || rightImageWithFallback === void 0 || (_rightImageWithFallba3 = rightImageWithFallback.props) === null || _rightImageWithFallba3 === void 0 ? void 0 : _rightImageWithFallba3.sx]);
  var commonProps = useMemo(function () {
    return {
      circularFrame: circularFrame,
      responsiveSizes: responsiveSizes,
      relativeImageSizeInLayout: relativeImageSizeInLayout,
      testId: testId
    };
  }, [circularFrame, relativeImageSizeInLayout, responsiveSizes, testId]);
  var leftImageProps = useMemo(function () {
    var _leftImageWithFallbac6;
    return _objectSpread(_objectSpread({}, commonProps), {}, {
      use: leftImageWithFallback !== null && leftImageWithFallback !== void 0 && (_leftImageWithFallbac6 = leftImageWithFallback.props) !== null && _leftImageWithFallbac6 !== void 0 && _leftImageWithFallbac6.use ? /*#__PURE__*/cloneElement(leftImageWithFallback.props.use, {
        // @NOTE: we are setting the width and height of the image to be the same
        // as the relative size of the image in the layout - these props are neccissary
        // for Next/Image components to work correctly
        width: relativeImageSizeInLayoutNumber,
        height: relativeImageSizeInLayoutNumber
      }) : undefined,
      sx: leftImageSx
    });
  }, [commonProps, leftImageWithFallback, leftImageSx, relativeImageSizeInLayoutNumber]);
  var rightImageProps = useMemo(function () {
    var _rightImageWithFallba4;
    return _objectSpread(_objectSpread({}, commonProps), {}, {
      use: rightImageWithFallback !== null && rightImageWithFallback !== void 0 && (_rightImageWithFallba4 = rightImageWithFallback.props) !== null && _rightImageWithFallba4 !== void 0 && _rightImageWithFallba4.use ? /*#__PURE__*/cloneElement(rightImageWithFallback.props.use, {
        // @NOTE: we are setting the width and height of the image to be the same
        // as the relative size of the image in the layout - these props are neccissary
        // for Next/Image components to work correctly
        width: relativeImageSizeInLayoutNumber,
        height: relativeImageSizeInLayoutNumber
      }) : undefined,
      sx: rightImageSx
    });
  }, [commonProps, rightImageWithFallback, rightImageSx, relativeImageSizeInLayoutNumber]);
  return jsxs(Box, _objectSpread(_objectSpread({}, props), {}, {
    testId: testId,
    className: "".concat(className !== null && className !== void 0 ? className : "", " SwapStack SwapStack--").concat(sizeClass, " SwapStack--").concat(direction, " SwapStack--").concat(circularFrame ? "circle" : "square"),
    sx: containerSx,
    children: [jsx(SmartClone, _objectSpread(_objectSpread({}, leftImageProps), {}, {
      children: leftImageWithFallback
    })), jsx(SmartClone, _objectSpread(_objectSpread({}, rightImageProps), {}, {
      children: rightImageWithFallback
    }))]
  }));
}
SwapStack.displayName = "SwapStack";
SwapStack.PrimaryImage = SwapStackPrimaryImage;
SwapStack.SecondaryImage = SwapStackSecondaryImage;

export { SwapStack as S };
//# sourceMappingURL=SwapStack.js.map
